const LOCALIZED_DASH_STREAM_ERROR_PATTERNS = [
  /Oops! Something went wrong\. Please try again\.?/i,
  /Connection to the assistant was lost(?: \((?:code \d+|no response from server)\))?\.? Please try again\.?/i,
  /Microsoft 365 approval state is still loading\s*[—-]\s*please retry\.?/i,
]

/**
 * Errors emitted by the shared WebSocket client are English protocol
 * messages. Dash renders these known recoverable failures with its own
 * localized retry copy while preserving unknown errors for diagnostics.
 */
export function shouldLocalizeDashStreamError(message: string): boolean {
  return LOCALIZED_DASH_STREAM_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}
